import React, { useState } from 'react';
import { resetPassword } from './api';
import MerkLogo from './MerkLogo';

// Reset-scherm dat geopend wordt via de e-maillink (?reset=<token>). Zet een nieuw
// wachtwoord; de 2FA blijft ongewijzigd. Na succes: terug naar inloggen (de
// ?reset-parameter wordt uit de URL gehaald zodat het login-scherm verschijnt).
export default function ResetPasswordPage({ token, brand }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const goToLogin = () => { window.location.assign(window.location.pathname); };

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Wachtwoord moet minimaal 8 tekens bevatten.'); return; }
    if (password !== confirm) { setError('De wachtwoorden komen niet overeen.'); return; }
    setLoading(true);
    try {
      await resetPassword(token, password);
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <MerkLogo brand={brand} />
          <h1 className="text-2xl font-bold text-slate-100">{brand?.name || "Partner Portal"}</h1>
          <p className="text-slate-400 mt-1">Nieuw wachtwoord instellen</p>
        </div>
        <div className="bg-slate-800/50 backdrop-blur-xl border border-slate-700/50 rounded-2xl p-8 space-y-5">
          {done ? (
            <>
              <div className="bg-lime-500/10 border border-lime-500/30 text-lime-300 px-4 py-3 rounded-xl text-sm">
                Je wachtwoord is opnieuw ingesteld. Je kunt nu inloggen met je nieuwe wachtwoord. Je tweestapsverificatie (2FA) is ongewijzigd gebleven.
              </div>
              <button onClick={goToLogin} className="w-full py-3 bg-gradient-to-r from-lime-500 to-lime-600 text-slate-900 font-semibold rounded-xl hover:from-lime-400 hover:to-lime-500 transition-all">
                Naar inloggen
              </button>
            </>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5">
              {error && <div className="bg-red-500/10 border border-red-500/30 text-red-400 px-4 py-3 rounded-xl text-sm">{error}</div>}
              <div>
                <label className="block text-sm font-medium text-slate-300 mb-2">Nieuw wachtwoord</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} required minLength={8} className="w-full px-4 py-3 bg-slate-700/50 border border-slate-600/50 rounded-xl text-slate-100 focus:outline-none focus:border-lime-500 focus:ring-1 focus:ring-lime-500 transition-colors" placeholder="Minimaal 8 tekens" />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-300 mb-2">Herhaal wachtwoord</label>
                <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required minLength={8} className="w-full px-4 py-3 bg-slate-700/50 border border-slate-600/50 rounded-xl text-slate-100 focus:outline-none focus:border-lime-500 focus:ring-1 focus:ring-lime-500 transition-colors" placeholder="••••••••" />
              </div>
              <button type="submit" disabled={loading} className="w-full py-3 bg-gradient-to-r from-lime-500 to-lime-600 text-slate-900 font-semibold rounded-xl hover:from-lime-400 hover:to-lime-500 transition-all disabled:opacity-50 disabled:cursor-not-allowed">
                {loading ? 'Bezig...' : 'Wachtwoord opslaan'}
              </button>
              <div className="text-center">
                <button type="button" onClick={goToLogin} className="text-sm text-slate-400 hover:text-lime-400 transition-colors">← Terug naar inloggen</button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
